import pako from "pako";

export const getHeaders = (token) => {
  const MAX_SIZE = 5120; // 5 KB

  if (typeof token === "string" && token.trim() !== "") {
    if (token.length > MAX_SIZE) {
      const compressed = gzipAndBase64Encode(token);
      if (compressed) {
        return {
          headers: {
            "X-Auth-Compressed": compressed,
          },
        };
      }
    }
  }
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const getHeadersForCsv = (token) => {
  const MAX_SIZE = 5120; // 5 KB

  if (typeof token === "string" && token.trim() !== "") {
    if (token.length > MAX_SIZE) {
      const compressed = gzipAndBase64Encode(token);
      if (compressed) {
        return {
          headers: {
            "X-Auth-Compressed": compressed,
          },
        };
      }
    }
  }
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "text/csv;charset=utf-8",
    },
  };
};

export const gzipAndBase64Encode = (token) => {
  try {
    const compressed = pako.gzip("Bearer " + token); // Uint8Array

    // Convert Uint8Array to binary string
    const binaryString = Array.from(compressed, (byte) =>
      String.fromCharCode(byte)
    ).join("");

    return btoa(binaryString);
  } catch (error) {
    return null;
  }
};
